export function split_string(str: string, trimParantness: boolean): string[] {
  const result = [];
  let buf = '';
  let isInsideParantness = false;

  for (let i = 0; i < str.length; i++) {
    const char = str[i];

    if (char === ' ') {
      if (isInsideParantness) {
        buf += char;
      } else {
        result.push(buf);
        buf = '';
      }
    } else if (char === '(') {
      isInsideParantness = true;
      if (!trimParantness) {
        buf += char;
      }
    } else if (char === ')') {
      isInsideParantness = false;
      if (!trimParantness) {
        buf += char;
      }
    } else {
      buf += char;
    }
  }

  if (buf) {
    result.push(buf);
  }

  return result;
}
